﻿/**
 * Class to work as a DTO to hold the information of a event dispatched the speedcurve mark end event.
 * This class help us to measure the time when a resource start @SpeedcuveMarkStart and when it ends.
 */
class SpeedcurveMarkEnd {
  constructor(measureName, markNameStart, markNameEnd) {
    this.measureName = measureName;
    this.markNameStart = markNameStart;
    this.markNameEnd = markNameEnd;
  }

  /**
   * The function returns the value of the measureName property.
   * @returns The value of the variable `measureName`.
   */
  getMeasureName() {
    return this.measureName;
  }

  /**
   * The function returns the value of the "markNameStart" property.
   * @returns The `markNameStart` property is being returned.
   */
  getMarkNameStart() {
    return this.markNameStart;
  }

  /**
   * The function returns the value of the "markNameEnd" property.
   * @returns The `markNameEnd` property is being returned.
   */
  getMarkNameEnd() {
    return this.markNameEnd;
  }
}

export default SpeedcurveMarkEnd;
